document.addEventListener("DOMContentLoaded", function() {
  
    var swiper = new Swiper('.product-main-slider', {
      lazy: true,
      loop: true,
      autoHeight: true,
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
      },
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
  });

    // Listen for cart frequency updates from main.js
    document.addEventListener('cart:frequency:updated', function(e) {
      if (e.detail && e.detail.frequency !== undefined) {
        updateSellingPlanFromFrequency(e.detail.frequency);
      }
    });
    
    // Update selling plan based on frequency value
    function updateSellingPlanFromFrequency(frequency) {
      // Determine which data attribute to use based on frequency (0-based)
      const planAttributeName = `plan-${frequency + 1}-month`;
      
      // Get all subscription radio buttons
      const subscriptionRadios = document.querySelectorAll('input[name="purchase-type"][id*="subscription"]');
      const shadowAddToCartButton = document.getElementById('shadow-add-to-cart');
      
      // Get the plan ID from the first subscription radio (if any exist)
      let planId = null;
      if (subscriptionRadios.length > 0) {
        planId = subscriptionRadios[0].getAttribute(`data-${planAttributeName}`);
      }
      
      // Update all subscription radios with the corresponding plan ID
      if (planId) {
        subscriptionRadios.forEach(radio => {
          radio.setAttribute('data-cart-selling-plan', planId);
        });
        
        // Update the shadow add to cart button if it exists
        if (shadowAddToCartButton) {
          shadowAddToCartButton.setAttribute('data-cart-selling-plan', planId);
        }
        
        // If there's an active subscription, update the hidden input if it exists
        const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
        const activeSubscription = document.querySelector('.subscription-option.active');
        if (sellingPlanInput && activeSubscription) {
          sellingPlanInput.value = planId;
        }
      }
    }

    function checkVariantAvailability() {
        
    const selectedVariant = document.querySelector('#Product-Variants-dropdown option:checked');
        // return if page doesn't have coll-purchase-options
        if (!document.querySelector('.coll-purchase-options') && document.querySelector(".black_friday_add_to_cart")) {
            const multiplicationFactorElement = document.querySelector(".qty_wrp_blf--wrp .selected_qty .qty_radio:checked");
            const multiplicationFactor = parseInt(multiplicationFactorElement?.value, 10) || 1;
            const { inventoryManagement, sellOutOfStock, quantity } = selectedVariant.dataset;
            const addToCartButton = document.querySelector(".black_friday_add_to_cart");
            const buttonTextSpan = addToCartButton.querySelector("span");
            if (inventoryManagement !== undefined && inventoryManagement !== null) {
                const isDenyAndInsufficientQuantity = sellOutOfStock === "deny" && parseInt(quantity, 10) < multiplicationFactor;
                
                addToCartButton.disabled = isDenyAndInsufficientQuantity;
                buttonTextSpan.textContent = isDenyAndInsufficientQuantity ? product.sold_out : product.add_to_cart;
              } else {
                addToCartButton.disabled = false;
                buttonTextSpan.textContent = product.add_to_cart;
              }
        } else {
            const selectedPurchaseType = document.querySelector('.coll-purchase-options.active').classList.contains('subscription-multiple-quantity-option');
            let multiplicationFactor = 1;
        
            if (selectedPurchaseType) {
                multiplicationFactor = 3;
            }
        
            if (selectedVariant.getAttribute('data-inventory-management') != undefined && selectedVariant.getAttribute('data-inventory-management') != null) {
                if (selectedVariant.getAttribute('data-sell-out-of-stock') == 'deny' && parseInt(selectedVariant.getAttribute('data-quantity')) < multiplicationFactor * parseInt(document.querySelector('.qty-selector option:checked').textContent)) {
                    document.querySelector('#ProductSubmitButton-'+product.section_id).setAttribute('disabled', true);
                    document.querySelector('#ProductSubmitButton-'+product.section_id+' span').textContent = product.sold_out;
                } else {
                    document.querySelector('#ProductSubmitButton-'+product.section_id).removeAttribute('disabled');
                    document.querySelector('#ProductSubmitButton-'+product.section_id+' span').textContent = 'IN WINKELMANDJE';
                }
            } else {
                document.querySelector('#ProductSubmitButton-'+product.section_id).removeAttribute('disabled');
                document.querySelector('#ProductSubmitButton-'+product.section_id+' span').textContent = 'IN WINKELMANDJE';
            }
        }
  }
  
  checkVariantAvailability();
  
  function updateContainerWidth() {
      var windowWidth = window.innerWidth;
  
      if (windowWidth <= 767) {
          document.querySelector('.slider-nav').style.width = windowWidth + 'px';
      } else if (windowWidth <= 1023) {
          var containerWidth = windowWidth * 0.75;
          document.querySelector('.slider-nav').style.width = containerWidth + 'px';
      } else {
          document.querySelector('.slider-nav').style.width = 100 + 'px';
      }
  }
  
  updateContainerWidth();
  
  window.addEventListener('resize', function() {
      updateContainerWidth();
  });
  
  document.querySelectorAll('.purchase-discount-box').forEach(function(element) {
      element.style.display = 'none';
  });
  
  function initializePurchaseOptions() {
    document.querySelectorAll('.purchase-type-radio').forEach(function(radio) {
        radio.removeEventListener('change', handlePurchaseTypeChange); // Prevent multiple bindings
        radio.addEventListener('change', handlePurchaseTypeChange);

        // Check if this radio is checked and its parent lacks the 'active' class, then trigger change
        if (radio.checked && !radio.closest('.coll-purchase-options').classList.contains('active')) {
            handlePurchaseTypeChange.call(radio); // Directly call the handler or radio.dispatchEvent(new Event('change'));
        }
    });

    // Initialize selling plan selection
    initializeSellingPlanSelection();
  }

  // Handle selling plan selection and update the hidden input and add-to-cart button
  function initializeSellingPlanSelection() {
    // First, add event listeners to the subscription type radio buttons
    document.querySelectorAll('input[name="purchase-type"]').forEach(radio => {
      radio.addEventListener('change', updateSellingPlanId);
    });

    // Then, add event listeners to the selling plan radio buttons
    document.querySelectorAll('input[name="selling_plan"]').forEach(radio => {
      radio.addEventListener('change', updateSellingPlanId);
    });

    // Initial update to set the correct values based on current selection
    updateSellingPlanId();
  }

  function updateSellingPlanId() {
    const purchaseTypeRadios = document.querySelectorAll('input[name="purchase-type"]');
    const selectedPurchaseType = Array.from(purchaseTypeRadios).find(radio => radio.checked);
    
    // Get the hidden input for the selling plan ID
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    // Get the shadow add-to-cart button
    const shadowAddToCartButton = document.getElementById('shadow-add-to-cart');
    
    let sellingPlanId = "";
    
    // Check if a subscription option is selected
    if (selectedPurchaseType && selectedPurchaseType.id.includes('subscription-radio')) {
      // Find the selected selling plan
      const sellingPlanRadios = document.querySelectorAll('input[name="selling_plan"]');
      const selectedSellingPlan = Array.from(sellingPlanRadios).find(radio => radio.checked);
      
      if (selectedSellingPlan) {
        sellingPlanId = selectedSellingPlan.value;
      }
    }
    
    // Update the hidden input value
    if (sellingPlanInput) {
      sellingPlanInput.value = sellingPlanId;
    }
    
    // Update the shadow add-to-cart button's data attribute
    if (shadowAddToCartButton) {
      shadowAddToCartButton.setAttribute('data-cart-selling-plan', sellingPlanId);
    }
  }

function handlePurchaseTypeChange() {
    if (this.classList.contains('purchase-type-radio')) {
        document.querySelectorAll('.coll-purchase-options').forEach(function(element) {
            element.classList.remove('active');
        });
        this.closest('.coll-purchase-options').classList.add('active');
        document.querySelectorAll('.purchase-discount-box').forEach(function(element) {
            element.style.display = (this.id === 'one-time-radio') ? 'block' : 'none';
        }.bind(this));
        checkVariantAvailability();
        
        // Update selling plan ID when purchase type changes
        updateSellingPlanId();
    }
}

initializePurchaseOptions();

document.body.addEventListener('change', function(e) {
    if (e.target && e.target.matches('.purchase-type-radio')) {
        handlePurchaseTypeChange.call(e.target);
    }
    
    // Update selling plan ID when any selling plan radio changes
    if (e.target && e.target.matches('input[name="selling_plan"]')) {
        updateSellingPlanId();
    }
});
  
  document.querySelectorAll('.coll-purchase-options').forEach(function(element) {
      element.addEventListener('click', function() {
          var radioInput = this.querySelector('input[type="radio"]');
          if (!radioInput.checked) {
              radioInput.checked = true;
              radioInput.dispatchEvent(new Event('change'));
          }
      });
  });

  document.body.addEventListener('click', function(event) {
    if (event.target.closest('.qty_wrp_blf_text')) {
        // Remove 'selected_qty' class from all elements
        document.querySelectorAll('.qty_wrp_blf_text').forEach(element => {
            element.classList.remove('selected_qty');
        });
        // Add 'selected_qty' class to the clicked '.qty_wrp_blf_text'
        const clickedElement = event.target.closest('.qty_wrp_blf_text');
        clickedElement.classList.add('selected_qty');
        // Check the radio button within the clicked element
        const radio = clickedElement.querySelector('.qty_radio');
        if (radio) {
            radio.checked = true;
        }
        checkVariantAvailability();
    }
});
  
  
  
  swiper.on('slideChange', function() {
    if (document.querySelectorAll('iframe[data-type="vimeovideo"]').length > 0) {   
      var current_index = this.realIndex + 1;
      var activeSlideClass = document.querySelector('.carousel-image[data-index="' + current_index + '"]');
      if(activeSlideClass != undefined && activeSlideClass != null){
        if (activeSlideClass.classList.contains('external_video')) {
            player = activeSlideClass.querySelector('iframe');
            player.contentWindow.postMessage(JSON.stringify({ method: 'play', value: 0 }), '*');
        } else {
            player = document.querySelector('.carousel-image iframe');
            player.contentWindow.postMessage(JSON.stringify({ method: 'pause', value: 0 }), '*');
        }
        }
    }
  });
  
  document.querySelectorAll('.sideNav_img').forEach(function(element, index) {
      element.addEventListener('click', function() {
          swiper.slideToLoop(index);
      });
  });

  
  function handleVideoStateChange() {
    const videoElement = document.querySelector('video');
    if (!videoElement) return;

    const videoElementParentDiv = videoElement.parentNode;
    const videoElementParentDivClasses = videoElementParentDiv.classList;

    if (
      videoElementParentDivClasses.contains('slick-active') &&
      videoElementParentDivClasses.contains('slick-current')
    ) {
      videoElement.play();
      videoElement.muted = false;
    } else {
      videoElement.pause();
      videoElement.muted = true;
    }
  }
  document.addEventListener('click', handleVideoStateChange);

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth',
      });
    });
  });
  document.querySelector('a.ruk_rating_snippet').addEventListener('click', function(event) {
    event.preventDefault();
    var targetId = this.getAttribute('href');
    var targetElement = document.querySelector(targetId);
    if (targetElement) {
        var targetOffset = targetElement.offsetTop;
        window.scrollTo({
            top: targetOffset,
            behavior: 'smooth'
        });
    }
});


createStickyVisibilityChecker('shadow-add-to-cart', '.product-form__buttons');
createStickyVisibilityChecker('shadow-add-to-cart', '.black_friday_add_to_cart');

});